import * as React from 'react';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import * as ReqType from '../../../types/ServerRequests';
import { TypeFile } from '../../../types/ServerRequests';
import { UserService } from '../../../services/UserService';

export interface Props {
    user_id: string;
    hidden: boolean;
}

interface State {
    files: ReqType.Fichiers[];
}

/**
 * Ce composant permet l'affichage des Documents du profil à telechargé
 */
export class DocumentsProfile extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            files: [],
        };
        this.getFiles();
    }

    // on click sur le formulaire d'inscription
    OnclickOnCM = () => {
        this.setState({ loading: true });
        var file = this.state.files.find(
            (f: ReqType.Fichiers) => {
                return (f.type_file === ReqType.TypeFile.CERTIFICATMEDICAL);
            }
        );
        if (file !== undefined) {
            return Promise.resolve(file.lien)
                .then(response => {
                    this.openInNewTab(response);
                }
                );
        }
        return Promise.reject('');
    }

    // on click sur l'attestation d'assurance
    onclickOnAA = () => {
        this.setState({ loading: true });
        var file = this.state.files.find(
            (f: ReqType.Fichiers) => {
                return (f.type_file === ReqType.TypeFile.ATTESTATIONASSURANCE);
            }
        );
        if (file !== undefined) {
            return Promise.resolve(file.lien)
                .then(response => {
                    this.openInNewTab(response);
                }
                );
        }
        return Promise.reject('');
    }

    // on click sur le formulaire d'adhesion
    OnclickOnFA = () => {
        this.setState({ loading: true });
        var file = this.state.files.find(
            (f: ReqType.Fichiers) => {
                return (f.type_file === ReqType.TypeFile.FORMULAIREADHESION);
            }
        );
        if (file !== undefined) {
            return Promise.resolve(file.lien)
                .then(response => {
                    this.openInNewTab(response);
                }
                );
        }
        return Promise.reject('');
    }

    // affichage des boutton pour télécharger les fichiers
    render() {
        if (this.state.files.length !== 0) {
            return (
                <div className="card card-default">
                    <div className="card-header col-12">
                        <h4 className="text-white">
                            <strong hidden={this.props.hidden}>Mes Documents</strong>
                            <strong hidden={!this.props.hidden}>Documents déposés</strong>
                        </h4>
                    </div>

                    <div className="card-body">
                        <div className="btn-group col-12" role="group">
                            {this.documentbuttons()}
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div />;
        }
    }

    private getFiles(): void {
        UserService.getInstance().getDocuments(this.props.user_id).then((response: ReqType.Fichiers[]) => {
            this.setState({ files: response });
        }
        );
    }

    private documentbuttons() {
        return (this.state.files.map((file: ReqType.Fichiers, index: number) => {
            if (file.type_file === TypeFile.CERTIFICATMEDICAL) {
                return (
                    <LoaderButton
                        className="btn"
                        style={{marginLeft: '30px'}}
                        modalTitle="Certificat Médical"
                        key={'certificat_medical'}
                        onClick={() => {
                            return this.OnclickOnCM();
                        }}
                    >
                        Certificat Médical
                    </LoaderButton>
                );
            }
            if (file.type_file === TypeFile.ATTESTATIONASSURANCE) {
                return (
                    <LoaderButton
                        className="btn"
                        modalTitle="Attestation d'assurance"
                        style={{marginLeft: '30px'}}
                        key={'attestation_assurance'}
                        onClick={() => {
                            return this.onclickOnAA();
                        }}
                    >
                        Attestation d'assurance
                    </LoaderButton>
                );
            }
            if (file.type_file === TypeFile.FORMULAIREADHESION) {
                return (
                    <LoaderButton
                        className="btn"
                        modalTitle="Formulaire d'adhesion"
                        style={{marginLeft: '30px'}}
                        key={'formulaire_adhesion'}
                        onClick={() => {
                            return this.OnclickOnFA();
                        }}
                    >
                        Formulaire d'adhesion
                    </LoaderButton>
                );
            }
            return undefined;
        })
        );

    }

    private openInNewTab(url: string) {
        var win = window.open(url, '_blank');
        if (win !== null) {
            win.focus();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/DocumentsProfile.tsx